import type { ListBuilderList } from '../../../types';
import {
	AGING_REQUIRED_FIELDS,
	BASE_FILTER_RULES,
	INVOICE_MOBILE_CARD_CONFIG,
} from '../shared';

/**
 * Current invoices - outstanding invoices not yet past due (due today or later)
 */
export const currentInvoicesList: ListBuilderList = {
	id: 'default-invoices-current',
	inheritsFrom: 'default-invoices-all',
	cacheTTL: 600000,
	name: 'Current',
	type: 'default',
	active: true,
	sortOrder: 2,
	description: 'Outstanding invoices not yet past due',
	defaultSortId: 'date-asc',
	requiredFields: AGING_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		invoicePaymentStatus: {
			defaultValue: [{ id: 'outstanding', label: 'Outstanding' }],
		},
		invoiceDueDateRange: {
			defaultValue: [
				{
					id: 'current',
					label: 'Current',
					data: {
						startDate: '{{DATE:0d}}',
					},
				},
			],
		},
		// Clear the default 90-day invoice date filter so all current invoices show
		invoiceDateRange: {
			defaultValue: [],
		},
	},
	mobileCardConfig: INVOICE_MOBILE_CARD_CONFIG,
};
